// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"35a1bccc","211":"3d98e78d","425":"dfc2e5cb"}[chunkId] + ".chunk.css";
};